// extracted by mini-css-extract-plugin
export default {"container":"GamePackage_container__ML8IF","EmptyContent":"GamePackage_EmptyContent__M0vgu","noContentButtons":"GamePackage_noContentButtons__XsPIw"};